import { Component } from '@angular/core';
import { DeliveryStatusType } from 'src/app/components/shared/api/gen_api_client/routing_pb';
import { StorageService } from 'src/app/components/shared/sharedServices/storage.service';
import { Filters } from 'src/app/components/shared/types/filters.type';
import { Flags } from 'src/app/components/shared/types/flags.type';
import { MuComponent } from 'src/app/components/shared/types/MuComponent.componetent';
import { TableColumn } from 'src/app/components/shared/types/tableColumn.type';
import { MassiveService } from '../../massive.service';
import { Request } from '../../models/request.interface';
import { RequestDataList } from '../../models/requestDataList.model';
import { RequestFilters } from '../../models/requestFilters.model';
import { MassiveRequestFlags } from './massive-request.flags';
import { Router } from '@angular/router';
import { Actions } from 'src/app/components/shared/types/actions.type';
import { MassiveRequestActions } from './massive-request.actions';
import { SelectItem } from 'primeng/api';
import { StorageClassifier } from 'src/app/components/shared/models/interface/storageClassifier.enum';
import { TableOption } from '../../models/tableOption.interface';

@Component({
  selector: 'app-massive-request',
  templateUrl: './request.component.html',
  styleUrls: ['./request.component.sass'],
})
export class RequestComponent extends MuComponent {
  requestFilters = new Filters<RequestFilters>(
    { storage: this.storageService, key: 'massive.requests', data: { page: 1, limit: 25 }, delay: 500 },
    'page',
    'limit'
  );
  requestTableColumns: TableColumn<Request, RequestFilters>[] = [];
  flags = new Flags<MassiveRequestFlags>();
  requestDataList: RequestDataList;
  tableOptionList: TableOption[] = [];
  requestActions = new Actions<MassiveRequestActions, Request>();
  statuses: SelectItem[] = [
    { label: 'Todos', value: DeliveryStatusType.CREATED },
    { label: 'Enrutados', value: DeliveryStatusType.ROUTED },
    { label: 'Sin Enrutar', value: DeliveryStatusType.PENDING_ROUTING },
  ];

  constructor(private storageService: StorageService, private massiveService: MassiveService, private router: Router) {
    super();
  }

  muOnInit(): void {
    this.requestActions.on(MassiveRequestActions.EDIT_ACTION, (_, value) => {
      const request = value as Request;
      this.storageService.removeValue(StorageClassifier.FILTER, 'massive.services');
      this.router.navigate(['masivos/services', `${request.routed ? 'r' : ''}${request.requestId}`]);
    });
    this.requestActions.on(MassiveRequestActions.PROGRAM_ACTION, (_, value) => {
      const request = value as Request;
      this.router.navigate(['masivos/program', request.requestId]);
    });
    this.tableOptionList = [
      {
        actionType: MassiveRequestActions.EDIT_ACTION,
        icon: 'edit',
      },
      {
        actionType: MassiveRequestActions.PROGRAM_ACTION,
        icon: 'truck',
      },
    ];
    this.requestTableColumns = [
      new TableColumn({
        filter: 'status',
        key: 'routed',
      }),
      new TableColumn({
        key: 'requestId',
      }),
      new TableColumn({
        key: 'company',
      }),
      new TableColumn({
        key: 'cedi',
      }),
      new TableColumn({
        key: 'cityName',
      }),
      new TableColumn({
        key: 'startDate',
        className: 'p-lg-2',
      }),
      new TableColumn({
        key: 'startTime',
      }),
      new TableColumn({
        key: 'endTime',
      }),
      new TableColumn({
        key: 'vehicleTypeName',
      }),
      new TableColumn({
        label: 'options',
        className: 'p-lg-1',
      }),
    ];
    this.flags.enable(MassiveRequestFlags.LOAD_REQUEST_TABLE);
    this.watch(this.requestFilters.filtersChanged).subscribe(filters => {
      this.loadRequest(filters);
    });
    this.requestFilters.emitFilterValue('status', DeliveryStatusType.CREATED);
    this.watch(this.flags.valueChanges(MassiveRequestFlags.SHOW_UPLOAD_EXCEL_PAGE)).subscribe(value =>
      this.router.navigate(['masivos/create'])
    );
  }

  loadRequest(filters: RequestFilters) {
    this.requestDataList = null;
    this.flags.execute(MassiveRequestFlags.LOAD_REQUEST_TABLE, async test => {
      if (test()) {
        this.requestDataList = await this.massiveService.listMassiveDelivery(filters);
      }
    });
  }

  muOnDestroy() {
    /** */
  }
}
